import { EventEmitter, Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class WorkorderStoreService {
  triggerUpdatedWO: EventEmitter<any> = new EventEmitter<any>();
  constructor() {}
  woUpdated(data: any) {
    this.triggerUpdatedWO.emit(data);
  }
}
